import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';

/**
 * Auth session for layout/routing shells.
 * Supabase session is the source of truth.
 */
export const useAuthSession = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    let active = true;

    const applySession = (session) => {
      if (!active) return;
      const authenticated = Boolean(session?.user);
      setIsAuthenticated(authenticated);
      if (authenticated) {
        localStorage.setItem('userAuthenticated', 'true');
        if (session.user?.email) {
          localStorage.setItem('userEmail', session.user.email);
        }
      }
      setLoading(false);
    };

    supabase.auth.getSession().then(({ data }) => {
      applySession(data?.session || null);
    }).catch(() => {
      if (!active) return;
      setIsAuthenticated(false);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      applySession(session);
    });

    return () => {
      active = false;
      subscription.unsubscribe();
    };
  }, []);

  return { isAuthenticated, loading };
};
